import React from 'react';
import './ScreenTabs.css';

function ScreenTabs({ screens, activeScreen, onChange }) {
  return (
    <nav className="screen-tabs" aria-label="Screen preview">
      {screens.map((screen) => (
        <button
          className={activeScreen === screen ? 'screen-tab active' : 'screen-tab'}
          key={screen}
          onClick={() => onChange(screen)}
          type="button"
        >
          {screen}
        </button>
      ))}
    </nav>
  );
}

export default ScreenTabs;
